var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPostImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75.75H1.25a.75.75 0 00-.75.75v15c0 .415.335.75.75.75h19.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75zm-.938 14.813H2.188v-.936l3.247-3.85 3.518 4.171 5.472-6.487 5.389 6.389v.713zm0-3.043L14.567 6.3a.186.186 0 00-.286 0l-5.33 6.319-3.374-4.001a.186.186 0 00-.286 0l-3.104 3.68v-9.86h17.625V12.52zM6.126 7.688a2.062 2.062 0 100-4.125 2.062 2.062 0 000 4.124zm0-2.72a.655.655 0 110 1.313.655.655 0 110-1.312z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/no-post-image.418c90d71cc1c6d40b9bf913e4c890c3.svg";
export { SvgNoPostImage as ReactComponent };